import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const RateContext = createContext({ rate: 149 });

export function RateProvider({ children }) {
  const [rate, setRate] = useState(149);

  useEffect(() => {
    api.get("/exchange-rate/eur")
      .then((r) => setRate(r.data.eur_to_dzd))
      .catch(() => {});
  }, []);

  return <RateContext.Provider value={{ rate }}>{children}</RateContext.Provider>;
}

export const useRate = () => useContext(RateContext);
